<template>
  <div class="__ListGroup">
    <ListWrapper
      :data="groups"
      :filter-keys="['group_name', 'group_id']"
      :filter-placeholder="$t('Search group')"
      :loading="loading"
    >
      <!--Header Actions-->
      <template v-slot:actions>
        <CButton icon="add" flat round @click="handleClickAction('create')" v-if="showAddButton" />
      </template>

      <!--Body-->
      <template v-slot:body="slotProps">
        <ListItem
          v-for="item in slotProps.data"
          :title="item.group_name"
          :description="`ID: ${item.group_id}`"
          :key="item.group_id"
          :active="selectedId === item.group_id"
          @click="handleClick(item.group_id)"
        ></ListItem>
      </template>
    </ListWrapper>

    <!--Dialog-->
    <DialogCreateGroup v-model="visibleCreateGroupModal" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import CButton from '@/components/uikit/CButton';
import ListWrapper from '@/pages/UsageReport/SideList/ListWrapper';
import ListItem from '@/pages/UsageReport/SideList/ListItem';
import DialogCreateGroup from '@/pages/UsageReport/DialogCreateGroup';

const messages = {
  messages: {
    en: {
      'Search group': 'Search group',
    },
    ja: {
      'Search group': 'グループを検索',
    },
  },
};

export default {
  name: 'ListGroup',
  i18n: messages,
  components: { CButton, ListWrapper, ListItem, DialogCreateGroup },
  data() {
    return {
      visibleCreateGroupModal: false,
    };
  },
  computed: {
    ...mapState('usageReports', {
      selectedId: state => state.id,
    }),

    ...mapState('groups', {
      groups: state => state.data,
    }),

    ...mapGetters('groups', {
      mappingGroupData: 'mappingGroupData',
    }),

    ...mapGetters('rbac', {
      shouldResourcesBeFiltered: 'shouldResourcesBeFiltered',
    }),

    showAddButton() {
      return (
        this.$can('ModifyGroups') && !this.shouldResourcesBeFiltered(['ModifyGroups'], 'group_id')
      );
    },

    groups() {
      return this.mappingGroupData;
    },

    loading() {
      return this.request && this.request.inProgress;
    },
  },
  methods: {
    ...mapMutations('groups', {
      selectGroup: 'selectGroup',
    }),

    handleClick(id) {
      this.selectGroup(id);
      this.$emit('click', id);
    },

    handleClickAction(actionType) {
      if (actionType === 'create') {
        this.visibleCreateGroupModal = true;
      }
    },
  },
};
</script>
